import axios from 'axios'

export default class LoginService {

    async login(email, pass) {

        const token = await this.getToken(email, pass)
        console.log(token)
        const res = await this.getUser(token)
        console.log('user:' + res)
        return res
    }

    async getToken(email, pass, captchaToken) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/authenticate',
                data: {
                    email: email,
                    password: pass,
                    captchaToken: captchaToken
                }
            })
            console.log('res je ' + res)
            return res.data.token

        } catch (error) {
            throw new Error(error.response.status)//TODO: refactor - vrati cijeli objekt ne samo status
        }


    }

    async getUser(token) {

        const res = await axios({
            method: 'get',
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/users/me',
            headers: {
                authorization: token
            }
        });
        return res.data
    }

    async changePassword(password, token) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/changePassword',
                data: { 
                    password: password, 
                    token: token
                }

            });
            return res
            
        } catch (error) {
            throw new Error(error)
        }
       
    }

    async sendResetPassMail(email) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/auth/register/changepassmail',
                data: { 
                    email: email
                }

            });
            return res
            
        } catch (error) {
            throw new Error(error)
        }
       
    }

}